import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Alert, Button, Form } from 'react-bootstrap';
import { saveReminderPreferences } from '../../actions/settings';
import { REMINDER_TYPES, DAYS_OF_WEEK, WEEK_ORDINALS } from '../../constants/reminderTypes';

function mapDispatchToProps(dispatch) {
  return {
    saveReminderPreferences: (prefs) => dispatch(saveReminderPreferences(prefs)),
  };
}

class ReminderPreferencesForm extends Component {
  constructor(props) {
    super(props);
    const prefs = props.reminderPreferences;
    this.state = {
      enabled: prefs ? prefs.enabled : false,
      reminderType: prefs ? prefs.reminderType : REMINDER_TYPES.INTERVAL,
      intervalDays: prefs && prefs.reminderConfig && prefs.reminderType === REMINDER_TYPES.INTERVAL
        ? prefs.reminderConfig.days : 7,
      monthlyDay: prefs && prefs.reminderConfig && prefs.reminderType === REMINDER_TYPES.MONTHLY_DATE
        ? prefs.reminderConfig.day : 15,
      weeklyDow: prefs && prefs.reminderConfig && prefs.reminderType === REMINDER_TYPES.WEEKLY
        ? prefs.reminderConfig.dayOfWeek : 1,
      monthlyWeekdayWeek: prefs && prefs.reminderConfig && prefs.reminderType === REMINDER_TYPES.MONTHLY_WEEKDAY
        ? prefs.reminderConfig.week : 1,
      monthlyWeekdayDow: prefs && prefs.reminderConfig && prefs.reminderType === REMINDER_TYPES.MONTHLY_WEEKDAY
        ? prefs.reminderConfig.dayOfWeek : 1,
      saved: false,
      saving: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  buildReminderConfig() {
    switch (this.state.reminderType) {
      case REMINDER_TYPES.INTERVAL:
        return { days: parseInt(this.state.intervalDays, 10) };
      case REMINDER_TYPES.MONTHLY_DATE:
        return { day: parseInt(this.state.monthlyDay, 10) };
      case REMINDER_TYPES.WEEKLY:
        return { dayOfWeek: parseInt(this.state.weeklyDow, 10) };
      case REMINDER_TYPES.MONTHLY_WEEKDAY:
        return {
          week: parseInt(this.state.monthlyWeekdayWeek, 10),
          dayOfWeek: parseInt(this.state.monthlyWeekdayDow, 10),
        };
      default:
        return {};
    }
  }

  async handleSubmit(e) {
    e.preventDefault();
    this.setState({ saving: true });
    await this.props.saveReminderPreferences({
      enabled: this.state.enabled,
      reminderType: this.state.reminderType,
      reminderConfig: this.buildReminderConfig(),
    });
    this.setState({ saving: false, saved: true });
    setTimeout(() => this.setState({ saved: false }), 3000);
  }

  render() {
    const { enabled, reminderType, saving, saved } = this.state;

    return (
      <Form onSubmit={this.handleSubmit} className="mt-2">
        <Form.Check
          type="switch"
          id="enable-reminders"
          label="Enable reminder emails"
          checked={enabled}
          onChange={e => this.setState({ enabled: e.target.checked })}
          className="mb-3"
        />

        {enabled && (
          <div className="ms-2 mb-3">
            <Form.Label className="fw-semibold">Cadence</Form.Label>

            <Form.Check
              type="radio"
              id="cadence-interval"
              name="cadence"
              label={
                <span>
                  Every{' '}
                  <Form.Control
                    type="number"
                    min="1"
                    max="365"
                    size="sm"
                    style={{ width: '70px', display: 'inline-block' }}
                    value={this.state.intervalDays}
                    onChange={e => this.setState({ intervalDays: e.target.value })}
                    disabled={reminderType !== REMINDER_TYPES.INTERVAL}
                  />{' '}
                  days
                </span>
              }
              checked={reminderType === REMINDER_TYPES.INTERVAL}
              onChange={() => this.setState({ reminderType: REMINDER_TYPES.INTERVAL })}
              className="mb-2"
            />

            <Form.Check
              type="radio"
              id="cadence-monthly-date"
              name="cadence"
              label={
                <span>
                  On the{' '}
                  <Form.Control
                    type="number"
                    min="1"
                    max="31"
                    size="sm"
                    style={{ width: '70px', display: 'inline-block' }}
                    value={this.state.monthlyDay}
                    onChange={e => this.setState({ monthlyDay: e.target.value })}
                    disabled={reminderType !== REMINDER_TYPES.MONTHLY_DATE}
                  />{' '}
                  of every month
                </span>
              }
              checked={reminderType === REMINDER_TYPES.MONTHLY_DATE}
              onChange={() => this.setState({ reminderType: REMINDER_TYPES.MONTHLY_DATE })}
              className="mb-2"
            />

            <Form.Check
              type="radio"
              id="cadence-weekly"
              name="cadence"
              label={
                <span>
                  Every{' '}
                  <Form.Select
                    size="sm"
                    style={{ width: '130px', display: 'inline-block' }}
                    value={this.state.weeklyDow}
                    onChange={e => this.setState({ weeklyDow: e.target.value })}
                    disabled={reminderType !== REMINDER_TYPES.WEEKLY}
                  >
                    {DAYS_OF_WEEK.map((day, i) => (
                      <option key={i} value={i}>{day}</option>
                    ))}
                  </Form.Select>
                </span>
              }
              checked={reminderType === REMINDER_TYPES.WEEKLY}
              onChange={() => this.setState({ reminderType: REMINDER_TYPES.WEEKLY })}
              className="mb-2"
            />

            <Form.Check
              type="radio"
              id="cadence-monthly-weekday"
              name="cadence"
              label={
                <span>
                  The{' '}
                  <Form.Select
                    size="sm"
                    style={{ width: '110px', display: 'inline-block' }}
                    value={this.state.monthlyWeekdayWeek}
                    onChange={e => this.setState({ monthlyWeekdayWeek: e.target.value })}
                    disabled={reminderType !== REMINDER_TYPES.MONTHLY_WEEKDAY}
                  >
                    {WEEK_ORDINALS.map(o => (
                      <option key={o.value} value={o.value}>{o.label}</option>
                    ))}
                  </Form.Select>{' '}
                  <Form.Select
                    size="sm"
                    style={{ width: '130px', display: 'inline-block' }}
                    value={this.state.monthlyWeekdayDow}
                    onChange={e => this.setState({ monthlyWeekdayDow: e.target.value })}
                    disabled={reminderType !== REMINDER_TYPES.MONTHLY_WEEKDAY}
                  >
                    {DAYS_OF_WEEK.map((day, i) => (
                      <option key={i} value={i}>{day}</option>
                    ))}
                  </Form.Select>{' '}
                  of every month
                </span>
              }
              checked={reminderType === REMINDER_TYPES.MONTHLY_WEEKDAY}
              onChange={() => this.setState({ reminderType: REMINDER_TYPES.MONTHLY_WEEKDAY })}
              className="mb-2"
            />
          </div>
        )}

        <Button type="submit" variant="primary" disabled={saving}>
          {saving ? 'Saving\u2026' : 'Save'}
        </Button>

        {saved && (
          <Alert variant="success" className="mt-2 d-inline-block ms-3 py-1 px-3">
            Preferences saved.
          </Alert>
        )}
      </Form>
    );
  }
}

export default connect(null, mapDispatchToProps)(ReminderPreferencesForm);
